import { GetDetailRequest } from '../../serverApi/requests/GetDetailRequest';
import { IResult } from '../../serverApi/types/IResponse';
import { ResultHelper } from '../../utils/ResultHelper';
import WebHttpClient from '../../WebHttpClient';
import { IDetailFetcher } from '../IDetailFetcher';

export class WebClientDetailFetcher<TResource, TRequestResult> implements IDetailFetcher<TResource> {

  constructor(
    private requestMethod: string,
    private resultMapper: (result: TRequestResult) => TResource
  ) { }

  public fetchById(id: string): Promise<TResource> {
    return WebHttpClient.sendRequest(new GetDetailRequest<TRequestResult>(this.requestMethod, id))
      .then(ResultHelper.rejectResultOnError())
      .then<TResource>(
        (result: TRequestResult) => Promise.resolve(this.resultMapper(result)),
        (result: IResult) => Promise.reject(result.errors && result.errors[0] && result.errors[0].code)
      );
  }

}
